<template>
	<transition-group
		v-testid="'notification-toasts'"
		tag="div"
		name="rc-notification"
		:class="$style['notification-toasts']"
	>
		<NotificationToast
			v-for="toast in visibleToasts"
			:key="toast.id"
			:notification="toast"
			:duration="duration"
			@close="$emit('close', $event)"
			@action="$emit('action', $event)"
			@success="$emit('success', $event)"
			@delete="$emit('delete', $event)"
		/>
	</transition-group>
</template>

<script>
import NotificationToast from './NotificationToast'

const MAX_VISIBLE_TOASTS = 3

export default {
	name: 'NotificationToasts',
	components: {
		NotificationToast
	},
	props: {
		toasts: {
			type: Array,
			required: true
		},
		duration: {
			type: Number,
			default: 5000
		}
	},
	computed: {
		visibleToasts () {
			// newest first: column-reverse places the first DOM child at the
			// bottom, so an expiring toast (oldest) is the DOM tail and its
			// removal doesn't shift siblings mid-leave
			return this.toasts.slice(-MAX_VISIBLE_TOASTS).reverse()
		}
	}
}
</script>

<style lang="scss" module>
.notification-toasts {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-end;
    gap: $gutter;
    pointer-events: auto;
}
</style>
